function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo, useRef, useState, useEffect, useCallback, useMemo } from 'react';
import scrollToNode from 'Functions/scrollToNode';
import bemit from 'Functions/bemit';
function isFixed(_ref) {
  if (!_ref?.current) return false;
  return _ref.current.getBoundingClientRect().top > 0 === false;
}
export default memo(function WithScrollListener(props) {
  // on garde les deux infos en même temps pour qu'elles soient changées en même
  // temps, sinon l'UI peut avoir un décallage entre deux mises à jour et donner
  // un mauvais feeling au scroll
  const [[fixed, height, width], setData] = useState([undefined, undefined]);
  const _ref_ticking = useRef();
  const _ref = useRef();
  useEffect(function () {
    document.addEventListener('scroll', handleScroll);
    function handleScroll(e) {
      if (_ref_ticking?.current === true) return;
      _ref_ticking.current = true;

      // évite plusieurs appel/fps
      window.requestAnimationFrame(function (e) {
        _ref_ticking.current = false;
        setData(function (data) {
          const [was_fixed, prev_height, width] = data;
          const new_is_fixed = isFixed(_ref);
          if (new_is_fixed !== was_fixed) {
            const dims = _ref.current.getBoundingClientRect();
            const height = new_is_fixed ? dims.height : '';
            return [new_is_fixed, height, dims.width || undefined];
          }
          return [new_is_fixed, prev_height, width];
        });
      });
    }
    return () => document.removeEventListener('scroll', handleScroll);
  }, []);
  return /*#__PURE__*/React.createElement(NavigationTabs, _extends({}, props, {
    fixed: fixed,
    height: height,
    width: width,
    _ref: _ref
  }));
});
function NavigationTabs({
  config,
  ...props
}) {
  if (!Array.isArray(config)) return null;
  const scrollToAnchor = useCallback(function (e) {
    if (!e?.target) return;
    const target = document.getElementById(e.target.getAttribute('href').split('#')[1]);
    if (!target) return;
    e.preventDefault();
    const tabs_height = props._ref?.current?.getBoundingClientRect?.()?.height;
    scrollToNode({
      node: target,
      offset: tabs_height,
      force: true
    });
  }, []);
  const links = config.map(function ({
    label,
    id,
    Icon,
    icon_suffix
  }) {
    if (props['hide-' + id]) return null;
    return /*#__PURE__*/React.createElement("li", {
      className: "c-establishment-navigation-tabs__item",
      key: id
    }, /*#__PURE__*/React.createElement("a", {
      href: '#' + id,
      onClick: scrollToAnchor,
      className: "c-establishment-navigation-tabs__link"
    }, Icon ? /*#__PURE__*/React.createElement(Icon, {
      className: 'c-establishment-navigation-tabs__icon' + (icon_suffix ? ' icon-' + icon_suffix : '')
    }) : undefined, label));
  });
  const [style, ul_style] = useMemo(function () {
    const style = !props.height || !props.fixed ? undefined : {
      height: props.height
    };
    const ul_style = !props.width || !props.fixed ? undefined : {
      minWidth: props.width
    };
    return [style, ul_style];
  }, [props.fixed, props.height, props.width]);
  return /*#__PURE__*/React.createElement("nav", {
    className: 'o-content js-establishment-tabs' + bemit('c-establishment-navigation-tabs', props.fixed ? ['fixed'] : []),
    ref: props._ref,
    style: style
  }, /*#__PURE__*/React.createElement("ul", {
    className: "c-establishment-navigation-tabs__list",
    style: ul_style
  }, links));
}
